import { useApi } from "hooks"
import { useQuery } from "@tanstack/react-query"

const useGetResume = (daysFrom = '') => {
  const { apiFetch } = useApi()

  const url = `/stats/dashboard/creator/resume?daysFrom=${daysFrom}`

  const getResume = () => {
    return apiFetch({ url })
      .then(res => res.data)
  }

  const options = {
    staleTime: 30000, // 30 seg
    placeholderData: null
  }

  return useQuery(['creators-resume', daysFrom], getResume, options)
}

export default useGetResume